import { AspectRatio, Box, Heading, Stack, Text } from '@chakra-ui/react';
import Button from '@components/interactive/Button';

const CovidVaccine = () => {
  return (
    <Box w="100%" p={3} mb="75px">
      <Stack spacing={5} pt="50px" m="0px auto" maxW="700px" w="100%">
        <Box shadow="xl">
          <AspectRatio>
            <iframe
              title="Covid Vaccine Form"
              src="https://form.typeform.com/to/h9SNAG7K?typeform-medium=embed-sdk&amp;typeform-embed=embed-widget&amp;typeform-source=fairsquaremedicare.com&amp;typeform-embed-id=5bkvi"
              style={{
                background: 'transparent; border: 1px solid #ccc',
              }}
            />
          </AspectRatio>
        </Box>
        <Heading pt={20}>Don't see your state here?</Heading>
        <Button href="https://daniel389714.typeform.com/to/JD8hlnT0">Add it</Button>
        <Heading>Questions? Suggestions</Heading>
        <Text fontSize="xl">Email help@fairsquaremedicare.com</Text>
      </Stack>
    </Box>
  );
};

export default CovidVaccine;
